/* THIS IS FILE IS AUTO-GENERATED BY graphql-codegen. DO NOT EDIT THIS FILE DIRECTLY! */
/* eslint-disable eslint-comments/no-unlimited-disable */
/* eslint-disable */
import * as Types from "../../../../types/definitions/vendor/graphql-schema.d";

import { DocumentNode } from "graphql";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type GetClientSelfieQueryVariables = Types.Exact<{ [key: string]: never }>;

export type GetClientSelfieQuery = {
  __typename?: "Query";
  client?: {
    __typename?: "Client";
    businessLine: Types.BusinessLine;
    id: string;
    selfieImageUrl?: string | null;
  } | null;
};

export const GetClientSelfieDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getClientSelfie" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "client" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "businessLine" } },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "selfieImageUrl" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetClientSelfieQuery__
 *
 * To run a query within a React component, call `useGetClientSelfieQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientSelfieQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClientSelfieQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetClientSelfieQuery(
  baseOptions?: Apollo.QueryHookOptions<GetClientSelfieQuery, GetClientSelfieQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetClientSelfieQuery, GetClientSelfieQueryVariables>(
    GetClientSelfieDocument,
    options,
  );
}
export function useGetClientSelfieLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetClientSelfieQuery, GetClientSelfieQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetClientSelfieQuery, GetClientSelfieQueryVariables>(
    GetClientSelfieDocument,
    options,
  );
}
// @ts-ignore
export function useGetClientSelfieSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetClientSelfieQuery,
    GetClientSelfieQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<GetClientSelfieQuery, GetClientSelfieQueryVariables>;
export function useGetClientSelfieSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetClientSelfieQuery, GetClientSelfieQueryVariables>,
): Apollo.UseSuspenseQueryResult<GetClientSelfieQuery | undefined, GetClientSelfieQueryVariables>;
export function useGetClientSelfieSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetClientSelfieQuery, GetClientSelfieQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetClientSelfieQuery, GetClientSelfieQueryVariables>(
    GetClientSelfieDocument,
    options,
  );
}
export type GetClientSelfieQueryHookResult = ReturnType<typeof useGetClientSelfieQuery>;
export type GetClientSelfieLazyQueryHookResult = ReturnType<typeof useGetClientSelfieLazyQuery>;
export type GetClientSelfieSuspenseQueryHookResult = ReturnType<
  typeof useGetClientSelfieSuspenseQuery
>;
export type GetClientSelfieQueryResult = Apollo.QueryResult<
  GetClientSelfieQuery,
  GetClientSelfieQueryVariables
>;
